import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import firebase from "firebase/app";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";

import { auth } from "../../firebase.config";
import history from "../../router/history";

//Material-UI
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import SentimentVerySatisfiedOutlinedIcon from "@material-ui/icons/SentimentVerySatisfiedOutlined";
import { CardActions } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import HomeIcon from "@material-ui/icons/Home";

const useStyles = makeStyles((theme) => ({
  signInRoot: {
    maxWidth: 345,
    margin: "auto",
    marginTop: 24,
  },
}));

function SignIn() {
  const user = useSelector((state) => state.auth);
  const classes = useStyles();

  // Configure FirebaseUI.
  const uiConfig = {
    // Popup signin flow rather than redirect flow.
    signInFlow: "redirect",
    // We will display Google and Facebook as auth providers.
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      firebase.auth.EmailAuthProvider.PROVIDER_ID,
    ],
    autoUpgradeAnonymousUsers: true,
    callbacks: {
      signInSuccessWithAuthResult: (authResult) => {
        history.push("/");
        return false;
      },
      signInFailure: (error) => {
        // For merge conflicts, the error.code will be
        // 'firebaseui/anonymous-upgrade-merge-conflict'.
        if (error.code !== "firebaseui/anonymous-upgrade-merge-conflict") {
          return Promise.resolve();
        }
        // The credential the user tried to sign in with.
        var cred = error.credential;
        history.push("/");
        return firebase.auth().signInWithCredential(cred);
      },
    },
  };

  if (user) {
    return (
      <Card className={classes.signInRoot}>
        <CardContent style={{ display: "grid" }}>
          <Typography gutterBottom variant="h5" component="h2" align="center">
            <SentimentVerySatisfiedOutlinedIcon style={{ fontSize: 150 }} />
          </Typography>
          <Typography gutterBottom variant="h5" component="h2" align="center">
            You're signed in!
          </Typography>
        </CardContent>
        <CardActions>
          <Button
            size="large"
            variant="contained"
            color="primary"
            startIcon={<HomeIcon />}
            style={{ margin: "auto" }}
            component={Link}
            to="/"
          >
            Home
          </Button>
        </CardActions>
      </Card>
    );
  }

  return (
    <Card className={classes.signInRoot}>
      <CardHeader title="Login" subheader="Choose your favorite login method" />
      <CardContent>
        <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={auth} />
      </CardContent>
    </Card>
  );
}

export default SignIn;
